// extracted by mini-css-extract-plugin
export default {"signUpLink":"sign-up-button_signUpLink__sx0kK","isAlone":"sign-up-button_isAlone__hiMHZ","textButton":"sign-up-button_textButton__XO0Bq"};